<template>
  <q-dialog v-model="shown">
    <q-card style="width: 400px;">
      <q-card-section class="row items-center q-mx-xs">
        <div class="text-h6">
          Select User Classes
        </div>
        <q-space />
        <q-btn
          v-close-popup
          icon="close"
          flat
          round
          dense
        />
      </q-card-section>
      <q-card-section>
        <q-list
          bordered
          separator
        >
          <q-item
            v-for="userClass in userClasses.data"
            :key="userClass.id"
            clickable
            @click="toggle(userClass)"
          >
            <q-item-section avatar>
              <q-checkbox
                :model-value="!!membershipUserTypesForUserClass(userClass)"
                :label="userClass.name"
                @update:model-value="toggle(userClass)"
              />
            </q-item-section>
          </q-item>
        </q-list>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script>

import MembershipType from 'src/models/membership-type/MembershipType'

export default {
  name: 'SelectMembershipUserTypesDialog',
  props: {
    modelValue: {
      type: Boolean,
      required: false
    },
    membershipType: {
      type: MembershipType,
      required: true
    }
  },
  emits: ['update:model-value'],
  data () {
    return {
      shown: false
    }
  },
  computed: {
  },
  watch: {
    modelValue () {
      this.shown = this.modelValue
    },
    shown () {
      this.$emit('update:model-value', this.shown)
    }
  },
  methods: {
    show () {
      this.shown = true
    },
    membershipUserTypesForUserClass (userClass) {
      return _.find(this.membershipType.membershipUserTypes.data, membershipUserType => membershipUserType.userClassId === userClass.id)
    },
    toggle (userClass) {
      const membershipUserType = this.membershipUserTypesForUserClass(userClass)
      if (membershipUserType) {
        membershipUserType.remove()
      } else {
        this.membershipType.membershipUserTypes.add({
          userClassId: userClass.id
        })
      }
    }
  },
  configuration: ['userClasses']
}

</script>

<style lang="scss" scoped>
</style>
